import { expiration } from 'creditcards';

export default (month) => {
  return expiration.month.isValid(
    expiration.month.parse(month)
  );
}
